<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            <v-btn @click="$router.go(-1)" icon class="mr-2">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            Pagamentos Recebidos por Período
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="form.data_inicial"
                  label="Data inicial"
                  type="date"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="form.data_final"
                  label="Data final"
                  type="date"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-list>
              <v-list-item @click="preencherHoje()" link>
                <v-list-item-content>
                  <v-list-item-title class="primary--text">
                    <v-icon left color="primary">mdi-creation</v-icon>
                    Hoje
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="preencherOntem()" link>
                <v-list-item-content>
                  <v-list-item-title class="primary--text">
                    <v-icon left color="primary">mdi-creation</v-icon>
                    Ontem
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="preencherUltimos7Dias()" link>
                <v-list-item-content>
                  <v-list-item-title class="primary--text">
                    <v-icon left color="primary">mdi-creation</v-icon>
                    Últimos 7 dias
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="preencherUltimos30Dias()" link>
                <v-list-item-content>
                  <v-list-item-title class="primary--text">
                    <v-icon left color="primary">mdi-creation</v-icon>
                    Últimos 30 dias
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="gerar()" :disabled="!podeGerar" color="primary">
              Gerar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <ServerPage
      :action="() => api.relatorios.pagamentosRecebidos(form)"
      :auto-load="false"
      ref="relatorio"
    >
      <template v-slot="{ serverData }">
        <v-card>
          <v-card-text>
            <v-data-table :headers="headers" :items="serverData.data">
              <template v-slot:item.nome_cliente="{ item }">
                <RouterLink
                  :to="{
                    name: 'pagina_cliente',
                    params: { id: item.client_id }
                  }"
                  target="_blank"
                >
                  {{ item.nome_cliente }}
                </RouterLink>
              </template>

              <template v-slot:item.perc="{ item }">
                {{ item.perc }}%
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </template>
    </ServerPage>
  </v-container>
</template>

<script>
import ServerPage from "@/components/server/ServerPage.vue";
import api from "@/services/locacoes";
import { formatDate } from "../../../utils/date";
import DateTimeMixin from "@/mixins/DateTimeMixin.js";

export default {
  mixins: [DateTimeMixin],

  components: {
    ServerPage
  },

  props: {},

  data() {
    return {
      api,
      form: {
        data_inicial: "",
        data_final: ""
      },
      headers: [
        {
          text: "Data",
          value: "data_pagamento",
          sortable: false
        },
        {
          text: "Cliente",
          value: "nome_cliente",
          sortable: false
        },
        {
          text: "Pagamento Ficha",
          value: "total_pagamento_ficha",
          sortable: false
        },
        {
          text: "Pagamento Locação",
          value: "total_pagamento_locacao",
          sortable: false
        },
        {
          text: "Perc",
          value: "perc",
          sortable: false
        }
      ]
    };
  },

  methods: {
    preencherHoje() {
      this.form.data_inicial = this.formatDateISO(new Date());
      this.form.data_final = this.formatDateISO(new Date());
    },
    preencherOntem() {
      this.form.data_inicial = this.formatDateISO(
        this.$moment().subtract(1, "days")
      );
      this.form.data_final = this.formatDateISO(
        this.$moment().subtract(1, "days")
      );
    },
    preencherUltimos7Dias() {
      this.form.data_inicial = this.formatDateISO(
        this.$moment().subtract(7, "days")
      );
      this.form.data_final = this.formatDateISO(new Date());
    },
    preencherUltimos30Dias() {
      this.form.data_inicial = this.formatDateISO(
        this.$moment().subtract(30, "days")
      );
      this.form.data_final = this.formatDateISO(new Date());
    },
    gerar() {
      this.$refs.relatorio.load();
    }
  },

  computed: {
    podeGerar() {
      return !!this.form.data_inicial && !!this.form.data_final;
    }
  }
};
</script>
